import React, { useEffect } from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import MaterialTable, { MTableToolbar } from 'material-table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Typography } from '@material-ui/core';
import { IsEmpty } from '../../common/checks';
import Colours from '../../styles/colours';

const themeTable = createMuiTheme({
  overrides: {
    MuiTableRow: {
      root: {
        '&:hover': {
          transition:      '0.3s ease',
          backgroundColor: '#42d1f5',
        },
      },
    },
  },
});

const PostalCodeTable = (props) => {
  const [value, setValue] = React.useState('1');
  const [postalCodeData, setPostalCodeData] = React.useState({});

  const getPostalCodes = async () => {
    if (!IsEmpty(props.data)) {
      setPostalCodeData(props.data);
    }
  };

  useEffect(() => {
    getPostalCodes();
  }, [props.data]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Paper className="" style={{ backgroundColor: Colours.Gray3 }}>
      <TabContext value={value}>
        <TabList onChange={handleChange} aria-label="tabs table">
          <Tab value="1" label={`Addresses (${postalCodeData.address ? postalCodeData.address.length : 0})`} style={{ color: '#f50057' }} />
          <Tab value="2" label={`Pages (${postalCodeData.pages ? postalCodeData.pages.length : 0})`} style={{ color: '#f50057' }} />
          <Tab value="3" label={`Promo Locations (${postalCodeData.promoLocations ? postalCodeData.promoLocations.length : 0})`} style={{ color: '#f50057' }} />
          <Tab value="4" label={`Outlets (${postalCodeData.outlets ? postalCodeData.outlets.length : 0})`} style={{ color: '#f50057' }} />
          <Tab value="5" label={`Review Locations (${postalCodeData.reviewLocations ? postalCodeData.reviewLocations.length : 0})`} style={{ color: '#f50057' }} />
        </TabList>

        <TabPanel value="1">
          <ThemeProvider theme={themeTable}>
            <MaterialTable
              components={{
                Toolbar: (p) => (
                  <div>
                    <MTableToolbar {...p} />
                    <div className="ml-5">
                      <Typography variant="body1" color="textSecondary" style={{ fontWeight: 'bold' }}>The following postal code(s) in Address either:</Typography>
                      <Typography variant="body1" color="textSecondary">1) has empty address</Typography>
                      <Typography variant="body1" color="textSecondary">2) has empty Lat & Lng</Typography>
                      <Typography variant="body1" color="textSecondary">3) Same lat & lng but different name</Typography>
                    </div>
                  </div>
                ),
              }}
              columns={[
                { title: 'Name', field: 'name' },
                { title: 'Postal Code', field: 'postalCode' },
                { title: 'Address', field: 'address' },
                { title: 'Lat', field: 'lat' },
                { title: 'Lng', field: 'lng' },
              ]}
              data={postalCodeData.address ? postalCodeData.address : []}
              title="Address"
            />
          </ThemeProvider>
        </TabPanel>

        <TabPanel value="2">
          <ThemeProvider theme={themeTable}>
            <MaterialTable
              components={{
                Toolbar: (p) => (
                  <div>
                    <MTableToolbar {...p} />
                    <div className="ml-5">
                      <Typography variant="body1" color="textSecondary" style={{ fontWeight: 'bold' }}>The postal code(s) of the following Live Pages (Mall or Hawker Centre) either:</Typography>
                      <Typography variant="body1" color="textSecondary">1) has empty Address</Typography>
                      <Typography variant="body1" color="textSecondary">2) has empty Lat & Lng</Typography>
                      <Typography variant="body1" color="textSecondary">3) has no corresponding Address record with the same postal code in our system</Typography>
                      <Typography variant="body1" color="textSecondary">4) Page's lat & lng doesn't match the Address record's lat & lng with the same postal code</Typography>
                    </div>
                  </div>
                ),
              }}
              columns={[
                { title: 'Page Id', field: 'id' },
                { title: 'Name', field: 'name' },
                { title: 'Page Type', field: 'type' },
                { title: 'Postal Code', field: 'postalCode' },
                { title: 'Address', field: 'address' },
                { title: 'Lat', field: 'lat' },
                { title: 'Lng', field: 'lng' },
                { title: 'Address Postal Code', field: 'addressPostalCode' },
                { title: 'Address Lat', field: 'addressLat' },
                { title: 'Address Lng', field: 'addressLng' },
              ]}
              data={postalCodeData.pages ? postalCodeData.pages : []}
              title="Pages"
            />
          </ThemeProvider>
        </TabPanel>

        <TabPanel value="3">
          <ThemeProvider theme={themeTable}>
            <MaterialTable
              components={{
                Toolbar: (p) => (
                  <div>
                    <MTableToolbar {...p} />
                    <div className="ml-5">
                      <Typography variant="body1" color="textSecondary" style={{ fontWeight: 'bold' }}>The following postal code(s) in Promo Location either:</Typography>
                      <Typography variant="body1" color="textSecondary">1) has empty Address</Typography>
                      <Typography variant="body1" color="textSecondary">2) has empty Lat & Lng</Typography>
                      <Typography variant="body1" color="textSecondary">3) does not have a corresponding Address record with the same postal code in our system</Typography>
                      <Typography variant="body1" color="textSecondary">4) Promo Location's lat & lng doesn't match the Address record's lat & lng with the same postal code</Typography>
                    </div>
                  </div>
                ),
              }}
              columns={[
                { title: 'Post Id', field: 'postId' },
                { title: 'Outlet Id', field: 'outletId' },
                { title: 'Postal Code', field: 'postalCode' },
                { title: 'Address', field: 'address' },
                { title: 'Lat', field: 'lat' },
                { title: 'Lng', field: 'lng' },
                { title: 'Address Postal Code', field: 'addressPostalCode' },
                { title: 'Address Lat', field: 'addressLat' },
                { title: 'Address Lng', field: 'addressLng' },
              ]}
              data={postalCodeData.promoLocations ? postalCodeData.promoLocations : []}
              title="Promo Locations"
            />
          </ThemeProvider>
        </TabPanel>

        <TabPanel value="4">
          <ThemeProvider theme={themeTable}>
            <MaterialTable
              components={{
                Toolbar: (p) => (
                  <div>
                    <MTableToolbar {...p} />
                    <div className="ml-5">
                      <Typography variant="body1" color="textSecondary" style={{ fontWeight: 'bold' }}>The following postal codes(s) in Outlets of Live Pages either:</Typography>
                      <Typography variant="body1" color="textSecondary">1) has empty Postal Code</Typography>
                      <Typography variant="body1" color="textSecondary">2) has empty Address</Typography>
                      <Typography variant="body1" color="textSecondary">3) has empty Lat & Lng</Typography>
                      <Typography variant="body1" color="textSecondary">4) does not have a corresponding Address record with the same postal code in our system</Typography>
                      <Typography variant="body1" color="textSecondary">5) Outlet's lat & lng doesn't match the Address record's lat & lng with the same postal code</Typography>
                      <Typography variant="body1" color="textSecondary">6) Outlet's locatedIn doesn't match the Address record's name with the same postal code</Typography>
                    </div>
                  </div>
                ),
              }}
              columns={[
                { title: 'Outlet Id', field: 'id' },
                { title: 'Outlet Name', field: 'name' },
                { title: 'Postal Code', field: 'postalCode' },
                { title: 'Address', field: 'address' },
                { title: 'Lat', field: 'lat' },
                { title: 'Lng', field: 'lng' },
                { title: 'Located In', field: 'locatedIn' },
                { title: 'Address Postal Code', field: 'addressPostalCode' },
                { title: 'Address Lat', field: 'addressLat' },
                { title: 'Address Lng', field: 'addressLng' },
              ]}
              data={postalCodeData.outlets ? postalCodeData.outlets : []}
              title="Outlets"
            />
          </ThemeProvider>
        </TabPanel>

        <TabPanel value="5">
          <ThemeProvider theme={themeTable}>
            <MaterialTable
              components={{
                Toolbar: (p) => (
                  <div>
                    <MTableToolbar {...p} />
                    <div className="ml-5">
                      <Typography variant="body1" color="textSecondary" style={{ fontWeight: 'bold' }}>The following postal code(s) in Review Location either:</Typography>
                      <Typography variant="body1" color="textSecondary">1) has no corresponding Address record with the same postal code in our system</Typography>
                      <Typography variant="body1" color="textSecondary">2) has empty address</Typography>
                      <Typography variant="body1" color="textSecondary">3) has empty Lat & Lng</Typography>
                    </div>
                  </div>
                ),
              }}
              columns={[
                { title: 'Review Id', field: 'reviewId' },
                { title: 'Postal Code', field: 'postalCode' },
                { title: 'Address', field: 'address' },
                { title: 'Lat', field: 'lat' },
                { title: 'Lat', field: 'lng' },
                { title: 'Address Postal Code', field: 'addressPostalCode' },
                { title: 'Address Lat', field: 'addressLat' },
                { title: 'Address Lng', field: 'addressLng' },
              ]}
              data={postalCodeData.reviewLocations ? postalCodeData.reviewLocations : []}
              title="Review Locations"
            />
          </ThemeProvider>
        </TabPanel>
      </TabContext>
    </Paper>
  );
};

PostalCodeTable.propTypes = {
  data: PropTypes.shape({}).isRequired,
};

export default connect(null, {
})(PostalCodeTable);
